const APP_VERSION = "v0.1.35";
let environment = import.meta.env.VITE_APP_ENVIRONMENT || "";
let isRunningLocally = import.meta.env.DEV;

const stripePkSandbox =
  "pk_test_51KrDMhE9DCOsh5Kqk0ob4ZmDxQp0jtvgRWp2HIJ5uiAa6go9LMPTBbRHysWQXiHoSGE7dz1s8TRvRYZlftobrZvl0093hjXNkJ";
const stripePkLive =
  "pk_live_51KrDMhE9DCOsh5KqrmIqgx94BNCZ4QBRG8rj8gVzBV85S7zVS77A2Y2FMKEJrAv9Z0UvDMFPc27OE7nwFrYnsJxA00Vkjv0DVj";

const razorpayKeyTesting = "rzp_test_irnPQxt2hSfRUv";
const razorpayKeyLive = "rzp_live_qPSF0upk1FnOaD";

let DATABASE_URL;
let STORAGE_ACCOUNT_NAME = "downloadtsl"
let CONTAINER_NAME_FOR_CONSUMPTION;
let CONTAINER_NAME_FOR_PROPOSAL_MEDIA;
let DATABASE_URL_FOR_WEBSOCKET;
let NOTIFICATIONS_WEBSOCKET_ENDPOINT;
let DATABASE_URL_FOR_SITE_SURVEY;
let BASE_URL_FOR_REPORT_IMAGES = window.location.origin + '/';
let SITE_SURVEY_LINK;
let STRIPE_PK;
let USE_CASHFREE_PROD;
let RAZORPAY_KEY;
let PRODUCTION_ENV;
let defaultBlockFootData;
let defaultPVTileId;
let defaultModuleId;
let defaultGazeboModuleId;
let defaultPatioModuleId;
let gazeboAllowedModules;
let gazeboInverterIQ7PLUSId = 6289;
let gazeboInverterIQ8PLUSId;
let lidarTiltApi;
let useLivePayments;
let es_org_id;
let patriot_org_id;
let pep_org_id;
let three_b_org_id;
let smart_energy_tx_org_id = -1;
let tata_org_id;
let havells_org_id = -1;
let suntek_org_id = -1;
let als_org_id = -1 // Advanced Level Solar
let org_id_to_add_site_survey_in_doc = 1885;
let getLogoBasedOnDomain = "https://downloadtsl.blob.core.windows.net/logos/Arka%20Logo%20-%20Black.png";
let logoForReport = getLogoBasedOnDomain;
let getLogoMarkBasedOnDomain = "https://downloadtsl.blob.core.windows.net/logos/Arka%20Logomark%20-%20Black.png"
let getOrgNameBasedOnDomain = "Arka 360"
let favIconLink = getLogoMarkBasedOnDomain;
let isIntercomEnabled = true;
let isHelpDocEnabled = true;
let isMsClarityEnabled = false;
let isLogoutDisabled = false;
let isRil = false;
let CONTAINER_NAME = "marketingportal";
let useBetaForBifacialGeneration = false;
let azureAppInsightsConnectionString = "InstrumentationKey=13d3d648-ff3f-4a5b-80d7-56ed7b1a6a82;IngestionEndpoint=https://centralindia-0.in.applicationinsights.azure.com/;LiveEndpoint=https://centralindia.livediagnostics.monitor.azure.com/"
let environmentError = ""
let containerNameBulkImport= 'bulk-import';
let containerNameForContracts = 'contracts';
let containerNameForEditorImages = 'logos'
let showLogoInProposal = true;
let powerModelNameMapping = {
  "PGUS01-M1-77-185-25": "Riviera",
  "PGUS01-M1-77-230-31": "Laguna",
  "PGUS01-M1-77-275-37": "Malibu",
  "PGUS01-M1-77-320-43": "Daytona",
  "PGUS01-M1-90-203-28": "Riviera XL",
  "PGUS01-M1-90-253-35": "Laguna XL",
  "PGUS01-M1-90-303-42": "Malibu XL",
  "PGUS01-M1-90-353-49": "Daytona XL",
  "PPUS01-M1-90-203-28": "Ehukai XL",
  "PPUS01-M1-90-252-35": "Kailua XL",
  "PPUS01-M1-90-303-42": "Waimea XL",
  "PPUS01-M1-90-353-49": "Waikiki XL"
};

let powerModelOldNewSKUMapping = {
  "PGUS01-M1-77-185-25": "PGUS01-M1-77-185-24",
  "PGUS01-M1-77-230-31": "PGUS01-M1-77-230-30",
  "PGUS01-M1-77-275-37": "PGUS01-M1-77-275-36",
  "PGUS01-M1-77-320-43": "PGUS01-M1-77-320-43",
  "PGUS01-M1-90-203-28": "PGUS02-M1-90-202-24",
  "PGUS01-M1-90-253-35": "PGUS02-M1-90-252-30",
  "PGUS01-M1-90-303-42": "PGUS02-M1-90-303-36",
  "PGUS01-M1-90-353-49": "PGUS02-M1-90-348-43",
  "PPUS01-M1-90-203-28": "PPUS02-M1-90-204-24",
  "PPUS01-M1-90-252-35": "PPUS02-M1-90-252-30",
  "PPUS01-M1-90-303-42": "PPUS02-M1-90-303-36",
  "PPUS01-M1-90-353-49": "PPUS02-M1-90-352-43"
};

// Handling missing environment errors
if (!environment) {
  if (isRunningLocally) {
    environmentError = "environment-not-set"
  } else {
    // For safety reasons, assuming 'prod' environment in case the
    // environment variable isn't available in non-local environments.
    environment = "prod";
  }
}


// For the important URLs (dev, beta, prod, RIL, US),
// override the environment variable.
if (!isRunningLocally) {
  let isDev = window.location.origin.includes('dev.arka360.com')
  let isBeta = window.location.origin.includes('beta.arka360.com')
  let isApp = window.location.origin.includes('app.arka360.com')
  let isRilDev = window.location.origin.includes('ril.arka360.com')
  let isRilProd = window.location.origin.includes('app.sdpd.rnel.com')
  let isLuminous = window.location.origin.includes('luminous')
  let isUs = window.location.origin.includes('us.arka360.com')
  
  if (isDev) {
    environment = 'dev'
  } else if (isBeta) {
    environment = 'beta'
  } else if (isApp) {
    environment = 'prod'
  } else if (isRilDev) {
    environment = 'dev.ril'
  } else if (isRilProd) {
    environment = 'prod.ril'
  } else if (isLuminous) {
    environment = 'prod.luminous'
  } else if (isUs) {
    environment = 'prod.US'
  }
}
let headEnvironment = environment.split('.')[0]
let subEnvironment = environment.split('.')[1]

// Head-environments
if (headEnvironment == "dev") {

  DATABASE_URL = "https://devapi.thesolarlabs.com/";
  if(subEnvironment === 'test') DATABASE_URL = "https://devtest.thesolarlabs.com:8004/";
  if(subEnvironment === 'US') DATABASE_URL = "https://dev-db-us.azurewebsites.net";
  DATABASE_URL_FOR_SITE_SURVEY = "https://devgosolar.arka360.com/";
  DATABASE_URL_FOR_WEBSOCKET = "wss://daphneprod.thesolarlabs.com:8000/ws/chat/";
  NOTIFICATIONS_WEBSOCKET_ENDPOINT = "wss://arka360websocketserver-dev.azurewebsites.net/notifications/"
  BASE_URL_FOR_REPORT_IMAGES = "https://dev.arka360.com/";
  lidarTiltApi = "https://designstudiodev.azurewebsites.net";
  SITE_SURVEY_LINK = "https://tsl-survey-tool-development.azurewebsites.net";
  useLivePayments = false;
  PRODUCTION_ENV = false;
  defaultModuleId = 24018;
  defaultGazeboModuleId = 23925;
  gazeboAllowedModules = [23925, 24016, 24017];
  es_org_id = 822;
  patriot_org_id = 855;
  pep_org_id = -1;
  tata_org_id = 263;
  gazeboInverterIQ8PLUSId = 9629;
  useBetaForBifacialGeneration = false
  defaultPatioModuleId = 24050;
  containerNameBulkImport= 'bulk-import'
  CONTAINER_NAME_FOR_CONSUMPTION = 'greenbutton'
  containerNameForContracts = 'contracts';
  containerNameForEditorImages = 'logos'
  CONTAINER_NAME_FOR_PROPOSAL_MEDIA = "proposal-media"
  defaultBlockFootData = {
    footing: {id: 2},
    ridgeCap: {id: 5, ridgeOverlap: 0.03},
    hipCap: {id: 6},
    valleyGutter: {id: 3},
    ridgeJunction: {id: 4, length: 0.5},
  }
  defaultPVTileId = 1;
  powerModelNameMapping = {
    "PGUS01-M1-77-185-25": "Riviera",
    "PGUS01-M1-77-230-31": "Laguna",
    "PGUS01-M1-77-275-37": "Malibu",
    "PGUS01-M1-77-320-43": "Daytona",
    "PGUS01-M1-90-203-28": "Riviera XL",
    "PGUS01-M1-90-253-35": "Laguna XL",
    "PGUS01-M1-90-303-42": "Malibu XL",
    "PGUS01-M1-90-353-49": "Daytona XL",
    "PPUS01-M1-90-203-28": "Ehukai XL",
    "PPUS01-M1-90-252-35": "Kailua XL",
    "PPUS01-M1-90-303-42": "Waimea XL",
    "PPUS01-M1-90-353-49": "Waikiki XL"
  };
  powerModelOldNewSKUMapping = {
    "PGUS01-M1-77-185-25": "PGUS01-M1-77-185-24",
    "PGUS01-M1-77-230-31": "PGUS01-M1-77-230-30",
    "PGUS01-M1-77-275-37": "PGUS01-M1-77-275-36",
    "PGUS01-M1-77-320-43": "PGUS01-M1-77-320-43",
    "PGUS01-M1-90-203-28": "PGUS02-M1-90-202-24",
    "PGUS01-M1-90-253-35": "PGUS02-M1-90-252-30",
    "PGUS01-M1-90-303-42": "PGUS02-M1-90-303-36",
    "PGUS01-M1-90-353-49": "PGUS02-M1-90-348-43",
    "PPUS01-M1-90-203-28": "PPUS02-M1-90-204-24",
    "PPUS01-M1-90-252-35": "PPUS02-M1-90-252-30",
    "PPUS01-M1-90-303-42": "PPUS02-M1-90-303-36",
    "PPUS01-M1-90-353-49": "PPUS02-M1-90-352-43"
  };
} else if (headEnvironment == "beta") {

  DATABASE_URL = "https://betaapi.thesolarlabs.com/";
  DATABASE_URL_FOR_SITE_SURVEY = "https://betagosolar.arka360.com/";
  DATABASE_URL_FOR_WEBSOCKET =
    "wss://daphneprod.thesolarlabs.com:8002/ws/chat/";
  // Using the prod notifications server for beta as well, to save resources
  NOTIFICATIONS_WEBSOCKET_ENDPOINT = "wss://arka360websocketserver.azurewebsites.net/notifications/"
  BASE_URL_FOR_REPORT_IMAGES = "https://beta.arka360.com/";
  lidarTiltApi = "https://designstudioapp.azurewebsites.net";
  SITE_SURVEY_LINK = "https://tsl-survey-tool.azurewebsites.net";
  useLivePayments = false;
  PRODUCTION_ENV = false;
  defaultModuleId = 30003;
  defaultGazeboModuleId = 28776;
  gazeboAllowedModules = [28776, 28776];
  es_org_id = 491;
  patriot_org_id = 1801;
  pep_org_id = 1896;
  three_b_org_id = 1563;
  smart_energy_tx_org_id = 2446;
  tata_org_id = 263;
  havells_org_id = 2142;
  suntek_org_id = 896;
  als_org_id = 2430 // Advanced Level Solar
  gazeboInverterIQ8PLUSId = 10931;
  useBetaForBifacialGeneration = false
  defaultPatioModuleId = 32118;
  CONTAINER_NAME = "prod-marketingportal";
  CONTAINER_NAME_FOR_CONSUMPTION = 'prod-greenbutton'
  containerNameBulkImport= 'bulk-import-prod'
  containerNameForContracts = 'prod-contracts';
  containerNameForEditorImages = 'logos'
  CONTAINER_NAME_FOR_PROPOSAL_MEDIA = "prod-proposal-media"
  defaultBlockFootData = {
    footing: {id: 2},
    ridgeCap: {id: 5, ridgeOverlap: 0.03},
    hipCap: {id: 6},
    valleyGutter: {id: 3},
    ridgeJunction: {id: 4, length: 0.5},
  }
  defaultPVTileId = 1;
  powerModelNameMapping = {
    "PGUS01-M1-77-185-24": "Riviera",
    "PGUS01-M1-77-230-30": "Laguna",
    "PGUS01-M1-77-275-36": "Malibu",
    "PGUS01-M1-77-320-43": "Daytona",
    "PGUS01-M1-90-202-28": "Riviera XL",
    "PGUS01-M1-90-252-36": "Laguna XL",
    "PGUS01-M1-90-303-43": "Malibu XL",
    "PGUS01-M1-90-348-50": "Daytona XL",
    "PPUS01-M1-90-204-28": "Ehukai XL",
    "PPUS01-M1-90-252-36": "Kailua XL",
    "PPUS01-M1-90-303-43": "Waimea XL",
    "PPUS01-M1-90-352-50": "Waikiki XL"
  };
  powerModelOldNewSKUMapping = {
    "PGUS01-M1-77-185-24": "PGUS01-M1-77-185-24",
    "PGUS01-M1-77-230-30": "PGUS01-M1-77-230-30",
    "PGUS01-M1-77-275-36": "PGUS01-M1-77-275-36",
    "PGUS01-M1-77-320-43": "PGUS01-M1-77-320-43",
    "PGUS01-M1-90-202-28": "PGUS02-M1-90-202-24",
    "PGUS01-M1-90-252-36": "PGUS02-M1-90-252-30",
    "PGUS01-M1-90-303-43": "PGUS02-M1-90-303-36",
    "PGUS01-M1-90-348-50": "PGUS02-M1-90-348-43",
    "PPUS01-M1-90-204-28": "PPUS02-M1-90-204-24",
    "PPUS01-M1-90-252-36": "PPUS02-M1-90-252-30",
    "PPUS01-M1-90-303-43": "PPUS02-M1-90-303-36",
    "PPUS01-M1-90-352-50": "PPUS02-M1-90-352-43"
  };

} else if (headEnvironment == "prod") {


  // Backend and Frontend URLs
  DATABASE_URL = "https://prodapi.thesolarlabs.com/";
  DATABASE_URL_FOR_SITE_SURVEY = "https://gosolar.arka360.com/";
  DATABASE_URL_FOR_WEBSOCKET =
    "wss://daphneprod.thesolarlabs.com:8002/ws/chat/";
  NOTIFICATIONS_WEBSOCKET_ENDPOINT = "wss://arka360websocketserver.azurewebsites.net/notifications/"
  BASE_URL_FOR_REPORT_IMAGES = "https://app.arka360.com/";
  lidarTiltApi = "https://designstudioapp.azurewebsites.net";
  SITE_SURVEY_LINK = "https://tsl-survey-tool.azurewebsites.net";
  
  
  // Functionality Variables
  useLivePayments = true;
  PRODUCTION_ENV = true;


  // Component IDs
  defaultModuleId = 30003;
  defaultGazeboModuleId = 28776;
  defaultPatioModuleId = 32118;
  gazeboAllowedModules = [28776, 28776];
  gazeboInverterIQ8PLUSId = 10931;
  defaultBlockFootData = {
    footing: {id: 2},
    ridgeCap: {id: 5, ridgeOverlap: 0.03},
    hipCap: {id: 6},
    valleyGutter: {id: 3},
    ridgeJunction: {id: 4, length: 0.5},
  }
  defaultPVTileId = 1;


  // Organisation IDs
  es_org_id = 491;
  patriot_org_id = 1801;
  pep_org_id = 1896;
  three_b_org_id = 1563;
  smart_energy_tx_org_id = 2446;
  tata_org_id = 263;
  havells_org_id = 2142;
  suntek_org_id = 896;
  als_org_id = 2430 // Advanced Level Solar
  
  // Azure Storage Containers
  CONTAINER_NAME = "prod-marketingportal";
  containerNameBulkImport= 'bulk-import-prod'
  CONTAINER_NAME_FOR_CONSUMPTION = 'prod-greenbutton'
  containerNameForContracts = 'prod-contracts';
  containerNameForEditorImages = 'logos';
  CONTAINER_NAME_FOR_PROPOSAL_MEDIA = "prod-proposal-media"


  // Analytics
  isMsClarityEnabled = true;
  azureAppInsightsConnectionString = "InstrumentationKey=cf9c53d6-5b69-4a3e-b36b-91ce7ea32781;IngestionEndpoint=https://southindia-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southindia.livediagnostics.monitor.azure.com/"


  if (subEnvironment === 'US') {
    // US Prod Environment
    DATABASE_URL = "https://produsapi.thesolarlabs.com/";
    DATABASE_URL_FOR_SITE_SURVEY = "https://us-gosolar.arka360.com/";
    DATABASE_URL_FOR_WEBSOCKET = "wss://20.42.60.205:8002/ws/chat/";
    NOTIFICATIONS_WEBSOCKET_ENDPOINT = "wss://us-arka360websocketserver.azurewebsites.net/notifications/"
    BASE_URL_FOR_REPORT_IMAGES = "https://us.arka360.com/";
    CONTAINER_NAME = "prod-us-marketingportal";
    containerNameBulkImport= 'bulk-import-prod-us'
    CONTAINER_NAME_FOR_CONSUMPTION = 'prod-us-greenbutton'
    azureAppInsightsConnectionString = null
  }
  powerModelNameMapping = {
    "PGUS01-M1-77-185-24": "Riviera",
    "PGUS01-M1-77-230-30": "Laguna",
    "PGUS01-M1-77-275-36": "Malibu",
    "PGUS01-M1-77-320-43": "Daytona",
    "PGUS01-M1-90-202-28": "Riviera XL",
    "PGUS01-M1-90-252-36": "Laguna XL",
    "PGUS01-M1-90-303-43": "Malibu XL",
    "PGUS01-M1-90-348-50": "Daytona XL",
    "PPUS01-M1-90-204-28": "Ehukai XL",
    "PPUS01-M1-90-252-36": "Kailua XL",
    "PPUS01-M1-90-303-43": "Waimea XL",
    "PPUS01-M1-90-352-50": "Waikiki XL"
  };
  powerModelOldNewSKUMapping = {
    "PGUS01-M1-77-185-24": "PGUS01-M1-77-185-24",
    "PGUS01-M1-77-230-30": "PGUS01-M1-77-230-30",
    "PGUS01-M1-77-275-36": "PGUS01-M1-77-275-36",
    "PGUS01-M1-77-320-43": "PGUS01-M1-77-320-43",
    "PGUS01-M1-90-202-28": "PGUS02-M1-90-202-24",
    "PGUS01-M1-90-252-36": "PGUS02-M1-90-252-30",
    "PGUS01-M1-90-303-43": "PGUS02-M1-90-303-36",
    "PGUS01-M1-90-348-50": "PGUS02-M1-90-348-43",
    "PPUS01-M1-90-204-28": "PPUS02-M1-90-204-24",
    "PPUS01-M1-90-252-36": "PPUS02-M1-90-252-30",
    "PPUS01-M1-90-303-43": "PPUS02-M1-90-303-36",
    "PPUS01-M1-90-352-50": "PPUS02-M1-90-352-43"
  };

} else {

  environmentError = "invalid-environment"

}


// This regex will match "dev.8015" but not "dev"
const featureEnvPattern = /^dev\.(?!dev)\d+$/gm
let isFeatureEnvironment = featureEnvPattern.test(environment)


// Sub-environments
if (subEnvironment == 'ril') {
  getLogoBasedOnDomain = "https://downloadtsl.blob.core.windows.net/logos/4VokEt2Cb0lHfJsfwEPUGsbjtI.svg";
  logoForReport = "https://downloadtsl.blob.core.windows.net/logos/4VokEt2Cb0lHfJsfwEPUGsbjtI.svg";
  getLogoMarkBasedOnDomain = "https://downloadtsl.blob.core.windows.net/logos/sensehawk_favicon.webp";
  getOrgNameBasedOnDomain = "SenseHawk";
  favIconLink = "https://downloadtsl.blob.core.windows.net/logos/sensehawk_favicon.webp";
  isIntercomEnabled = false;
  isHelpDocEnabled = false;
  isLogoutDisabled = false;
  isRil = true;

  if (headEnvironment != "dev") {
    DATABASE_URL_FOR_SITE_SURVEY = "https://app.gosolar.rnel.com/";
  }
} else if (subEnvironment == 'luminous') {
  DATABASE_URL_FOR_SITE_SURVEY = "https://gosolar.arka360.com/";
  // getLogoBasedOnDomain = "https://downloadtsl.blob.core.windows.net/logos/luminous_logo.png";
  logoForReport = "https://downloadtsl.blob.core.windows.net/logos/luminous_logo.png"; // TODO: later on this variable will be removed
  getLogoMarkBasedOnDomain = "https://downloadtsl.blob.core.windows.net/logos/Luminous_favicon.ico";
  getOrgNameBasedOnDomain = "Luminous";
  favIconLink = "https://downloadtsl.blob.core.windows.net/logos/Luminous_favicon.ico";
  showLogoInProposal = false
} else if (isFeatureEnvironment) {
  DATABASE_URL = `https://devfeatures.thesolarlabs.com:${subEnvironment}/`;
}

const favicon = document.getElementById("favicon");
favicon.setAttribute("href", favIconLink);
document.title = getOrgNameBasedOnDomain;

// Microsoft clarity
if (isMsClarityEnabled) {
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "fvjgfvwbes");
}

// Microsoft Azure Application Insights
if (!isRunningLocally && azureAppInsightsConnectionString) {
  !(function (cfg){function e(){cfg.onInit&&cfg.onInit(i)}var S,u,D,t,n,i,C=window,x=document,w=C.location,I="script",b="ingestionendpoint",E="disableExceptionTracking",A="ai.device.";"instrumentationKey"[S="toLowerCase"](),u="crossOrigin",D="POST",t="appInsightsSDK",n=cfg.name||"appInsights",(cfg.name||C[t])&&(C[t]=n),i=C[n]||function(l){var d=!1,g=!1,f={initialize:!0,queue:[],sv:"7",version:2,config:l};function m(e,t){var n={},i="Browser";function a(e){e=""+e;return 1===e.length?"0"+e:e}return n[A+"id"]=i[S](),n[A+"type"]=i,n["ai.operation.name"]=w&&w.pathname||"_unknown_",n["ai.internal.sdkVersion"]="javascript:snippet_"+(f.sv||f.version),{time:(i=new Date).getUTCFullYear()+"-"+a(1+i.getUTCMonth())+"-"+a(i.getUTCDate())+"T"+a(i.getUTCHours())+":"+a(i.getUTCMinutes())+":"+a(i.getUTCSeconds())+"."+(i.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z",iKey:e,name:"Microsoft.ApplicationInsights."+e.replace(/-/g,"")+"."+t,sampleRate:100,tags:n,data:{baseData:{ver:2}},ver:4,seq:"1",aiDataContract:undefined}}var h=-1,v=0,y=["js.monitor.azure.com","js.cdn.applicationinsights.io","js.cdn.monitor.azure.com","js0.cdn.applicationinsights.io","js0.cdn.monitor.azure.com","js2.cdn.applicationinsights.io","js2.cdn.monitor.azure.com","az416426.vo.msecnd.net"],k=l.url||cfg.src;if(k){if((n=navigator)&&(~(n=(n.userAgent||"").toLowerCase()).indexOf("msie")||~n.indexOf("trident/"))&&~k.indexOf("ai.3")&&(k=k.replace(/(\/)(ai\.3\.)([^\d]*)$/,function(e,t,n){return t+"ai.2"+n})),!1!==cfg.cr)for(var e=0;e<y.length;e++)if(0<k.indexOf(y[e])){h=e;break}var i=function(e){var a,t,n,i,o,r,s,c,p,u;f.queue=[],g||(0<=h&&v+1<y.length?(a=(h+v+1)%y.length,T(k.replace(/^(.*\/\/)([\w\.]*)(\/.*)$/,function(e,t,n,i){return t+y[a]+i})),v+=1):(d=g=!0,o=k,c=(p=function(){var e,t={},n=l.connectionString;if(n)for(var i=n.split(";"),a=0;a<i.length;a++){var o=i[a].split("=");2===o.length&&(t[o[0][S]()]=o[1])}return t[b]||(e=(n=t.endpointsuffix)?t.location:null,t[b]="https://"+(e?e+".":"")+"dc."+(n||"services.visualstudio.com")),t}()).instrumentationkey||l.instrumentationKey||"",p=(p=p[b])?p+"/v2/track":l.endpointUrl,(u=[]).push((t="SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details)",n=o,r=p,(s=(i=m(c,"Exception")).data).baseType="ExceptionData",s.baseData.exceptions=[{typeName:"SDKLoadFailed",message:t.replace(/\./g,"-"),hasFullStack:!1,stack:t+"\nSnippet failed to load ["+n+"] -- Telemetry is disabled\nHelp Link: https://go.microsoft.com/fwlink/?linkid=2128109\nHost: "+(w&&w.pathname||"_unknown_")+"\nEndpoint: "+r,parsedStack:[]}],i)),u.push((s=o,t=p,(r=(n=m(c,"Message")).data).baseType="MessageData",(i=r.baseData).message='AI (Internal): 99 message:"'+("SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details) ("+s+")").replace(/\"/g,"")+'"',i.properties={endpoint:t},n)),o=u,c=p,JSON&&((r=C.fetch)&&!cfg.useXhr?r(c,{method:D,body:JSON.stringify(o),mode:"cors"}):XMLHttpRequest&&((s=new XMLHttpRequest).open(D,c),s.setRequestHeader("Content-type","application/json"),s.send(JSON.stringify(o))))))},a=function(e,t){g||setTimeout(function(){!t&&f.core||i()},500),d=!1},T=function(e){var n=x.createElement(I),e=(n.src=e,cfg[u]);return!e&&""!==e||"undefined"==n[u]||(n[u]=e),n.onload=a,n.onerror=i,n.onreadystatechange=function(e,t){"loaded"!==n.readyState&&"complete"!==n.readyState||a(0,t)},cfg.ld&&cfg.ld<0?x.getElementsByTagName("head")[0].appendChild(n):setTimeout(function(){x.getElementsByTagName(I)[0].parentNode.appendChild(n)},cfg.ld||0),n};T(k)}try{f.cookie=x.cookie}catch(p){}function t(e){for(;e.length;)!function(t){f[t]=function(){var e=arguments;d||f.queue.push(function(){f[t].apply(f,e)})}}(e.pop())}var r,s,n="track",o="TrackPage",c="TrackEvent",n=(t([n+"Event",n+"PageView",n+"Exception",n+"Trace",n+"DependencyData",n+"Metric",n+"PageViewPerformance","start"+o,"stop"+o,"start"+c,"stop"+c,"addTelemetryInitializer","setAuthenticatedUserContext","clearAuthenticatedUserContext","flush"]),f.SeverityLevel={Verbose:0,Information:1,Warning:2,Error:3,Critical:4},(l.extensionConfig||{}).ApplicationInsightsAnalytics||{});return!0!==l[E]&&!0!==n[E]&&(t(["_"+(r="onerror")]),s=C[r],C[r]=function(e,t,n,i,a){var o=s&&s(e,t,n,i,a);return!0!==o&&f["_"+r]({message:e,url:t,lineNumber:n,columnNumber:i,error:a,evt:C.event}),o},l.autoExceptionInstrumented=!0),f}(cfg.cfg),(C[n]=i).queue&&0===i.queue.length?(i.queue.push(e),i.trackPageView({})):e();})({
  src: "https://js.monitor.azure.com/scripts/b/ai.3.gbl.min.js",
  // name: "appInsights",
  // ld: 0,
  // useXhr: 1,
  crossOrigin: "anonymous",
  // onInit: null,
  // cr: 0,
  cfg: { // Application Insights Configuration
   connectionString: azureAppInsightsConnectionString,
  }}); 
}

// Setting Payments variables
if (useLivePayments) {
  STRIPE_PK = stripePkLive;
  USE_CASHFREE_PROD = true;
  RAZORPAY_KEY = razorpayKeyLive;
} else {
  STRIPE_PK = stripePkSandbox;
  USE_CASHFREE_PROD = false;
  RAZORPAY_KEY = razorpayKeyTesting;
}

if (!isRunningLocally) {
  BASE_URL_FOR_REPORT_IMAGES = window.location.origin + '/';
}

// Constant to be replaced by a feature toggle
const AUTOMATION_ENABLED = true;
const ROBOFLOW_ROOF_URL = "https://outline.roboflow.com/arkasegmentationproject/7";
const ROBOFLOW_OBSTRUCTIONS_URL  = "https://outline.roboflow.com/roofobstructionsdetect/4"
const ROBOFLOW_API_KEY = "9pyHdiM1tENb1DwODp1M";
const AI_SERVER_URL = "https://autoroof.thesolarlabs.com";

// const GOOGLE_API_KEY = "AIzaSyB03FdBoXg_cEe7xWRkbs0ySmMsgMUWrS0" // old
const GOOGLE_API_KEY = "AIzaSyCRKem7aP2ORcLP9jmBSIADnrmgxzQNWEg"; // new
const GOOGLE_MAP_ID =  '420d254e3af914b9';
const GOOGLE_API_KEY_TILES = "AIzaSyBOVbQ7oSTZZVfg4eVzBCYifEMT-tx-5sI";
const GOOGLE_SIGNING_SECRET = "xte8ioISnvNiBiCaCeuEtUfLE-0=";
const COUNTRYSTATECITY_API_KEY = "YVNFNGpzYW45Rk5EaTVqbFdmZGdaelR6YlVsVDlqaE5qQ1Z2NWJ5Wg=="
const SAVE_REPORT_LAMBDA_ENDPOINT =
  "https://udlt2cbkgpskt7blcrjw2uky3q0rbmhz.lambda-url.ap-south-1.on.aws/";
const STAGE_REPORT_LAMBDA_ENDPOINT =
  "https://hxzb3wckog4uk26bxxvnzkdz6m0nwqkj.lambda-url.ap-south-1.on.aws/"; // stageReport
// const STAGE_REPORT_LAMBDA_ENDPOINT = "https://5nltgrxshc.execute-api.ap-south-1.amazonaws.com/default/stageReport2" // stageReport2
const SAVE_CONTRACTS_ENDPOINT = 
  "https://6nbf6zseak7fietf7drja3mzoy0jbobm.lambda-url.ap-south-1.on.aws/"
export const binaryPalette = ['212121', 'B3E5FC'];
export const rainbowPalette = ['3949AB', '81D4FA', '66BB6A', 'FFE082', 'E53935'];
export const ironPalette = ['00000A', '91009C', 'E64616', 'FEB400', 'FFFFF6'];
export const sunlightPalette = ['212121', 'FFCA28'];
export const panelsPalette = ['E8EAF6', '1A237E'];

export {
  APP_VERSION,
  environment as VITE_APP_ENVIRONMENT, // Do not import this variable, unless you're absolutely sure it is required.
  DATABASE_URL,
  DATABASE_URL_FOR_WEBSOCKET,
  DATABASE_URL_FOR_SITE_SURVEY,
  STORAGE_ACCOUNT_NAME,
  CONTAINER_NAME_FOR_CONSUMPTION,
  CONTAINER_NAME_FOR_PROPOSAL_MEDIA,
  NOTIFICATIONS_WEBSOCKET_ENDPOINT,
  BASE_URL_FOR_REPORT_IMAGES,
  STRIPE_PK,
  USE_CASHFREE_PROD,
  RAZORPAY_KEY,
  SITE_SURVEY_LINK,
  AUTOMATION_ENABLED,
  ROBOFLOW_ROOF_URL,
  ROBOFLOW_OBSTRUCTIONS_URL,
  ROBOFLOW_API_KEY,
  AI_SERVER_URL,
  GOOGLE_API_KEY,
  GOOGLE_MAP_ID,
  GOOGLE_API_KEY_TILES,
  GOOGLE_SIGNING_SECRET,
  COUNTRYSTATECITY_API_KEY,
  SAVE_REPORT_LAMBDA_ENDPOINT,
  STAGE_REPORT_LAMBDA_ENDPOINT,
  SAVE_CONTRACTS_ENDPOINT,
  PRODUCTION_ENV,
  defaultModuleId,
  defaultBlockFootData,
  defaultPVTileId,
  defaultGazeboModuleId,
  defaultPatioModuleId,
  gazeboAllowedModules,
  lidarTiltApi,
  
  // Organisation IDs
  es_org_id,
  patriot_org_id,
  pep_org_id,
  three_b_org_id,
  smart_energy_tx_org_id,
  tata_org_id,
  havells_org_id,
  suntek_org_id,
  als_org_id,
  org_id_to_add_site_survey_in_doc,
  
  getLogoBasedOnDomain,
  logoForReport,
  getLogoMarkBasedOnDomain,
  getOrgNameBasedOnDomain,
  isIntercomEnabled,
  isHelpDocEnabled,
  isLogoutDisabled,
  gazeboInverterIQ7PLUSId,
  gazeboInverterIQ8PLUSId,
  isRil,
  useBetaForBifacialGeneration,
  environmentError,
  containerNameBulkImport,
  containerNameForContracts,
  containerNameForEditorImages,
  CONTAINER_NAME,
  powerModelNameMapping,
  powerModelOldNewSKUMapping,
  showLogoInProposal,
  headEnvironment
};
